import React from 'react';
import PropTypes from 'prop-types';

// Components
import { MapLayerWrapper as Layer } from '../../Common';

// Constants
import { LAYERS } from '../Constants';

// Theme & Utils
import { colors } from '../../../Core/Theme';
import { createHash } from '../../../Core/Utils';

// Layer properties
const fillProperties = {
  id: LAYERS.USER_RESERVED_DESK,
  type: 'fill',
  source: 'features',
  paint: {
    'fill-color': colors.palette.primary.light,
  },
};
const lineProperties = {
  id: `${LAYERS.USER_RESERVED_DESK}-lines`,
  type: 'line',
  source: 'features',
  paint: {
    'line-color': colors.palette.primary.main,
    'line-width': 1,
    'line-opacity': 1,
  },
};

// Legend
const legend = {
  key: LAYERS.USER_RESERVED_DESK,
  style: {
    backgroundColor: colors.palette.primary.light,
    borderColor: colors.palette.primary.main,
    borderWidth: 1,
    borderStyle: 'solid',
  },
  labelKey: 'deskFloorPlan.legend.userReservedDesk',
};

const UserReservedDesk = props => {
  const { desks } = props;
  return (
    <Layer
      key={`${LAYERS.USER_RESERVED_DESK}-${createHash(desks)}`}
      properties={[fillProperties, lineProperties]}
      filter={['in', ['get', 'id'], ['literal', desks]]}
      {...props}
    />
  );
};

UserReservedDesk.defaultProps = {
  desks: [],
};
UserReservedDesk.propTypes = {
  desks: PropTypes.arrayOf(PropTypes.string),
};

export { legend };
export default React.memo(UserReservedDesk);
